import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { getIsMobile, getIsWhitelabel } from 'src/store/view/selectors';
import type { IReviewsItem } from 'src/components/Reviews/ReviewsItem/ReviewsItem';
import {
  getReviewsLTShowMoreVisible,
  getReviewsLTVisible,
  getHotelReviewsLink,
} from 'src/store/reviews/selectors';

import { showMoreReviews } from 'src/store/reviews/slice';

import { ReviewsLevelTravel } from './ReviewsLevelTravel';

const mapStateToProps = (state) => ({
  items: getReviewsLTVisible(state) as IReviewsItem[] | undefined,
  isShowMoreVisible: getReviewsLTShowMoreVisible(state),
  isMobile: getIsMobile(state),
  isWhitelabel: getIsWhitelabel(state),
  hotelReviewsLink: getHotelReviewsLink(state),
});

const mapDispatchToProps = {
  showMore: showMoreReviews,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ReviewsLevelTravel);
